import React, { Component, useEffect, useState } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Box from '@material-ui/core/Box';
import axios from 'axios';
import { withTranslation, Trans, withNamespaces } from 'react-i18next';
import CustomToaster from './CustomToaster';

import '../css/modal.style.css';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

const CustomListModal = ({ isOpen, product_id, jwt, savedList, setIsOpenBack, data, api_url, api_origin }) => {
    
    const [open, setOpen] = useState(false);
    const [isFev, setIsFev] = useState(false);
    const [listName, setListName] = useState("");

    const [listId, setListId] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [headContent, setHeadContent] = useState('');

    const [draftName, setDraftName] = useState();
    const [draftList, setDraftList] = useState();
    const [showToast, setShowToast] = useState(false);
    const [selectedId, setSelectedId] = useState(false);
    const [listDetailsModal, setListDetailsModal] = useState(false);

    const handleClose = () => {
        setOpen(false);
        setListName("");
        setIsOpenBack(false);
        setSelectedId(false);
        setListDetailsModal(false);
    };

    useEffect(  () => {
        setOpen(isOpen);
    }, [isOpen]);    
    
    const createList = async () => {
        let drftLst = await axios.get(api_url+`/projects?filter=project_status:0`, 
            {   
                headers: {
                    "Accept": "application/json, text/javascript, */*; q=0.01",
                    "Authorization": jwt
                }
            }
        );

        setAlertType("lstn");
        setHeadContent("Please enter template name");

        if(drftLst){
            if(listName){
                setListDetailsModal(true);
                setDraftList(drftLst.data.data);
            }else{
                // alert("Please enter list name");
                setShowToast(true);
                
                closeToaster();
            }
        }
    }
    
    const handelChangeListName = (e) => {
        e.preventDefault();
        setListName(e.target.value);
    }

    const selectList = (e, id) => {
        e.preventDefault();
        setSelectedId(id);
    }
    
    const checkFavorite = (e, stat) => {
        e.preventDefault();
        setIsFev(stat);
    }
    
    const addToList = async (e) => {
        e.preventDefault();

        if (selectedId) {
            
            const listAddStatus = await commonAddToList(selectedId);
            
            if (listAddStatus) {
                setAlertType("lst");
                setHeadContent("Product added to template");
                setListId(selectedId);
                setShowToast(true);
                // alert("Product added to list");
            }
            
        }else{
            setAlertType("lstn");
            setHeadContent("Please choose a template");
            setShowToast(true);
            // alert("Please choose a list");
        }

        closeToaster();
    }

    const setDraft = (e) => {
        e.preventDefault();
        setDraftName(e.target.value);
    }

    const addProductOldTemplate = async (e) => {
        
        e.preventDefault();

        if (draftName) {

            setAlertType("lst");
            setHeadContent("Product added to new template");

            let fev = 0;
            if(isFev){
                fev = 1;
            }
            const data = JSON.stringify({
                "list_name"     :   listName,
                "description"   :   "",
                "icon"          :   "",
                "color"         :   "#564578",
                "is_favorite"   :   fev
            });
            
            let crtLstStat = await axios.post(api_url+`/projects/${draftName}/lists`, data,
            {   
                headers: {
                        "Accept": "application/json, text/javascript, */*; q=0.01",
                        "Authorization": jwt
                    }
                }
            );
    
            if (crtLstStat) {
                let last_list_id = crtLstStat.data.data.list_id;
                const listAddStatus = await commonAddToList(last_list_id);
                if (listAddStatus) {
                    setListId(last_list_id);
                    setShowToast(true);
                    closeToaster();
                    // alert("Product added to new list");
                }
            }            
        }else{
            setAlertType("lstn");
            setHeadContent("Please choose a project");
            setShowToast(true);
            closeToaster();
            // alert("Please choose a project");
        }

    }

    const commonAddToList = async (list_id) => {

        const data = JSON.stringify({
            "ori_product_id": product_id,
            "product_id": product_id,
            "quantity": "1",
        });

        let addToListStatus = await axios.post(api_url+`/lists/${list_id}/list-lines`, data,
        {
            headers: {
                "Accept": "application/json, text/javascript, */*; q=0.01",
                "Authorization": jwt
            }
        });

        if (addToListStatus) {
            handleClose();
            return addToListStatus;
        }else{
            // alert("Somthing went wrong");
            setAlertType("lstn");
            setHeadContent("Somthing went wrong");
            
            setShowToast(true);
            closeToaster();
            return false;
        }

    }

    const renderList = (lists) => {
        return (lists.map((list, indx) => {
            return <li key={indx} className={selectedId == list.list_id ? 'active' : ""} onClick={(e) => selectList(e, list.list_id)}><em className="list-icon"><img className="iconImg" src="../../newDesigning/images/product-placeholder-icon.svg" alt="list" /></em>{list.list_name}</li>
        }));
    }

    const closeToaster = () => {
        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    }

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography className='popup-content' id="modal-modal-title" variant="h6" component="h3">
                        <span className="close-popup" onClick={handleClose}>
                            <img className="crossBtn" src="../../newDesigning/images/close-gray.svg" alt="close" />
                        </span>
                        <em className="list-icon">
                            <img className="listSVG" src="../../newDesigning/images/product-list.svg" alt="list" />
                        </em>
                        <p className="fh4"><Trans>ADD THE PRODUCT TO A TEMPLATE</Trans></p>
                        <p><Trans>Where do you want to add it?</Trans></p>
                    </Typography>
                    {listDetailsModal ? 
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            <div className="product-listing-block" id="list-block">
                                <div className="form-group product-list-btn-wrapper">
                                    <div className="details-wrapper">
                                        <ul>
                                            <li>
                                                <p><Trans>Icon</Trans></p>
                                                <div className="right-block">
                                                    <em>
                                                        <img 
                                                            src="../../newDesigning/images/product-placeholder-icon.svg" 
                                                            alt="product-placeholder-icon"
                                                            className='iconImg'
                                                        />
                                                    </em>
                                                </div>
                                            </li>
                                            <li>
                                                <p><Trans>Name</Trans></p>
                                                <div className="right-block">
                                                    <input 
                                                        type="text" 
                                                        // id="new-list-name" 
                                                        // name='listName'
                                                        // onChange={(e) => handelChangeListName(e)}
                                                        className="form-control addTxtFld"
                                                        placeholder="List Name"
                                                        value={listName}
                                                        readOnly
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <p><Trans>Project</Trans></p>
                                                <div className="right-block">
                                                    <select className="form-control " onChange={(e) => setDraft(e)}>
                                                        <option value="0">Select Project</option>
                                                        {draftList?.map((drft, indx) => {
                                                            return <option key={indx} value={drft.project_id}>{drft.project_name}</option>
                                                        })}
                                                    </select>
                                                </div>
                                            </li>
                                            <li>
                                                <p><Trans>Favourite</Trans></p>
                                                <div className="right-block">
                                                    <em>
                                                        {!isFev
                                                        ?
                                                            <img 
                                                                src="../../newDesigning/images/wishlist-gray.svg" 
                                                                alt="wishlist"
                                                                onClick={(e) => checkFavorite(e, true)}
                                                                className='iconImg'
                                                            />
                                                        :
                                                            <img 
                                                                src="../../newDesigning/images/heart-icon.svg" 
                                                                alt="wishlist"
                                                                onClick={(e) => checkFavorite(e, false)}
                                                                className='iconImg'
                                                            />
                                                        }
                                                    </em>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="g-btn-wrapper">
                                    <button className="new-green-btn" onClick={(e) => addProductOldTemplate(e)}><Trans>Add</Trans></button>
                                </div>
                            </div>
                        </Typography>
                    : 
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            <div className="product-listing-block" id="list-block">
                                <div className="form-group list-wrapper">
                                    <input 
                                        type="text" 
                                        id="new-list-name" 
                                        name='listName'
                                        className="form-control addTxtFld" 
                                        placeholder="Create a template"
                                        onChange={(e) => handelChangeListName(e)}
                                    />
                                    <button 
                                        className="new-green-btn" 
                                        onClick={ () => createList() }
                                    >
                                        <Trans>Create</Trans>
                                    </button>
                                </div>
                                <div className="custom-scrollbar">
                                    <ul className="product-list-name"  style={{cursor: 'pointer'}}>

                                        {savedList &&  savedList.length > 0 ?
                                            renderList( savedList)
                                        :
                                            ""
                                        }
                                        {/* List will render here */}
                                    </ul>
                                </div>
                                <div className="btn-wrapper">
                                    <div className="qty-wrapper secondary" ></div>
                                    <button className="blue-btn" onClick={(e) => addToList(e)}><Trans>Add</Trans></button>
                                </div>
                            </div>
                        </Typography>
                    }
                </Box>
            </Modal>
            {showToast ? 
                <CustomToaster
                    data={data}
                    alertType={alertType}
                    headContent={headContent}
                    sId={data.id.raw}
                    listId={listId}
                    lang={data.lang}
                />
            : ""}
        </div>
    );
}

export default withTranslation()(CustomListModal);